import { MESSAGE_TYPES } from './MessageTypes.js';
import { IMessageHandler } from './IMessageHandler.js';
import { logger } from '@/utils/logger';

/**
 * 消息处理器基类
 * 使用策略模式处理不同类型的消息，遵循开闭原则
 */
export class MessageProcessor extends IMessageHandler {
  constructor() {
    super();
    this.processors = new Map();
    this._registerProcessors();
  }

  /**
   * 注册消息处理器
   * 遵循开闭原则，新增消息类型时只需添加新的处理器
   */
  _registerProcessors() {
    // 注册各种消息类型的处理器 - 使用子窗体的消息类型
    this.processors.set(MESSAGE_TYPES.CHAT_READY, this._handleChatReady.bind(this));
    this.processors.set(MESSAGE_TYPES.CHAT_LOG, this._handleChatLog.bind(this));
    this.processors.set(
      MESSAGE_TYPES.SWITCH_CONVERSATION_SUCCESS,
      this._handleSwitchConversationSuccess.bind(this)
    );

    this.processors.set(MESSAGE_TYPES.NOTIFY_COMPLETE, this._handleNotifyComplete.bind(this));
  }

  /**
   * 处理消息
   * @param {MessageEvent} event - 消息事件
   * @param {HTMLIFrameElement} iframe - iframe元素
   * @param {Object} callbacks - 回调函数集合
   */
  handleMessage(event, iframe, callbacks) {
    const { type, data } = event.data;

    // 获取对应的处理器
    const processor = this.processors.get(type);
    if (processor) {
      try {
        processor(data, callbacks);
      } catch (error) {
        logger.error(`[MessageProcessor] 处理消息失败: ${type}`, error);
      }
    } else {
      logger.warn(`[MessageProcessor] 未找到消息处理器: ${type}`);
    }
  }

  /**
   * 清理资源
   */
  cleanup() {
    this.processors.clear();
  }

  // 具体的消息处理方法 - 使用子窗体的消息类型
  _handleChatReady(data, callbacks) {
    // 处理聊天就绪消息
    if (data.ready) {
      // 聊天初始化成功
      if (callbacks.onInitSuccess) {
        callbacks.onInitSuccess(data);
      }
    } else {
      // 聊天初始化失败
      if (callbacks.onInitError) {
        callbacks.onInitError(data.error);
      }
    }
  }

  _handleChatLog(data) {
    // 处理聊天日志消息
    logger.log('[MessageProcessor] 收到聊天日志:', data);
  }

  _handleSwitchConversationSuccess(data, callbacks) {
    if (callbacks.onSwitchConversationSuccess) {
      callbacks.onSwitchConversationSuccess(data);
    }
  }

  _handleNotifyComplete(data, callbacks) {
    if (callbacks.onNotifyComplete) {
      callbacks.onNotifyComplete(data);
    }
  }
}
